<button
  mat-button
  matTooltip="{{ 'TOOLBAR.ONLINE_USERS_TOOLTIP' | translate }}"
  matTooltipShowDelay="400"
  matTooltipHideDelay="400"
  [matMenuTriggerFor]="onlineUsersMenu"
  class="tool-btn">
  <mat-icon class="mat-icon" svgIcon="online-users"></mat-icon>
</button>

<mat-menu #onlineUsersMenu="matMenu">
  <div class="users-online">
    <p class="users-online__label">{{ 'TOOLBAR.ONLINE_USERS' | translate }}</p>
    <div class="horizontal-separator"></div>
    <div class="user-item" *ngFor="let user of usersOnline?.users">
      <div class="user-data">
        <app-user-circle [user]="user" [locked]="user.locked"></app-user-circle>
        <div class="user-item__name">
          {{ user | transform: getFullName }}
        </div>
      </div>
      <mat-divider></mat-divider>
    </div>
    <div *ngIf="usersOnline?.oddAmount" class="users-online__more-users">
      + {{ usersOnline?.oddAmount }}
      <span *ngIf="usersOnline?.oddAmount === 1">{{ 'TOOLBAR.MORE_USER' | translate }}</span>
      <span *ngIf="usersOnline?.oddAmount > 1">{{ 'TOOLBAR.MORE_USERS' | translate }}</span>
    </div>
  </div>
</mat-menu>
